<app-auth-layout>
  <ng-template #AuthContent>

    <h3 class="text-center">{{'registration' | translate}}</h3>

    <form (ngSubmit)="signUpSubmission(form.value)" [formGroup]="form" autocomplete="off" novalidate>
      <div class="row">

        <!--          <mat-form-field appearance="outline" class="material-form col-md-12">-->
        <!--            <mat-label> National Identification Number</mat-label>-->
        <!--            <input formControlName="nationalId" matInput maxlength="20" minlength="20" type="text">-->
        <!--            <mat-hint>Andika kama ilivyo kwenye kitambulisho chako bila alama ya -</mat-hint>-->

        <!--            <mat-icon matSuffix>card_membership</mat-icon>-->

        <!--            <mat-error>-->
        <!--                  <span *ngIf="!form.get('nationalId').valid && form.get('nationalId').touched">-->
        <!--                      NIDA Number is required-->
      <!--                  </span>-->
    <!--            </mat-error>-->
  <!--          </mat-form-field>-->

  <mat-form-field appearance="outline" class="material-form col-md-12">
    <mat-label> {{'email' | translate}}</mat-label>
    <input formControlName="email" matInput type="email">
    <mat-icon matSuffix>mail</mat-icon>
    <mat-error>
      @if (!form.get('email').valid && form.get('email').touched) {
        <span>
          {{'field-is-required' | translate}}
        </span>
      }
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="material-form col-md-12">
    <mat-label> {{'firstName' | translate}}</mat-label>
    <input formControlName="firstName" matInput type="text">
    <mat-error>
      @if (!form.get('firstName').valid && form.get('firstName').touched) {
        <span>
          {{'field-is-required' | translate}}
        </span>
      }
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="material-form col-md-12">
    <mat-label> {{ 'middleName' | translate}}</mat-label>
    <input formControlName="middleName" matInput type="text">
  </mat-form-field>

  <mat-form-field appearance="outline" class="material-form col-md-12">
    <mat-label> {{'lastName' | translate}}</mat-label>
    <input formControlName="lastName" matInput type="text">
    <mat-error>
      @if (!form.get('lastName').valid && form.get('lastName').touched) {
        <span>
          {{'field-is-required' | translate}}
        </span>
      }
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="material-form col-md-12">
    <mat-label> {{'gender' | translate}}</mat-label>
    <mat-select formControlName="gender">
      <mat-option value="MALE">Male</mat-option>
      <mat-option value="FEMALE">Female</mat-option>
    </mat-select>
    <mat-error>
      @if (!form.get('gender').valid && form.get('gender').touched) {
        <span>
          {{'field-is-required' | translate}}
        </span>
      }
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="material-form col-md-12">
    <mat-label> {{'dob' | translate}}</mat-label>
    <input matInput [matDatepicker]="picker" [max]="minDate" formControlName="dateOfBirth">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error>
      @if (!form.get('dateOfBirth').valid && form.get('dateOfBirth').touched) {
        <span>
          {{'field-is-required' | translate}}
        </span>
      }
    </mat-error>
  </mat-form-field>

</div>

<div class="col-md-12 text-end">
  <button [disabled]="!form.valid" class="btn" color="primary" mat-raised-button type="submit">
    {{'continue' | translate}}
    <mat-icon>login</mat-icon>
  </button>
</div>

</form>

<div class="col-md-12 ">
  {{'already-have-account' | translate}}
  <button mat-stroked-button routerLink="/login" type="button">{{'login' | translate}}</button>
</div>

</ng-template>
</app-auth-layout>
